import {
  TwitterIcon,
  FacebookIcon,
  PinterestIcon,
  WhatsappIcon,
  LinkedinIcon,
  FacebookShareButton,
  PinterestShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share';
import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import { Tabs, Panel } from '@bumaga/tabs';
import { CONDITION_MAPPING } from '../../../../utils/constants';
import { Marker, Popup } from 'react-leaflet';
import { Tab, degToCard, createIcon} from '../../../../utils/utils';

const PoiMarker = props => {
  const {
    item,
    setters: { setImages, setIsOpenImageBox, setIsPopupOpen }
  } = props;
  let comments = '';
  const isWeather = !_.isEmpty(item.weather);
  const isDetails =
    (item.photos && item.photos.length > 0) ||
    (item.comments && item.comments.length > 0);
  const shareFooter = 'https://www.raknroll.pl';
  const shareLink =
    item.photos && item.photos.length > 0
      ? item.photos[0]
      : 'https://www.raknroll.pl/rolling2zwrotnik/';
  return (
    <Marker
      position={item.coordinates}
      icon={createIcon(item)}
    >
      <Popup
        onClose={() => setIsPopupOpen(false)}
        onOpen={() => setIsPopupOpen(true)}
      >
        <Tabs>
          <div className="tabs">
            <div className="tab-list">
              {isDetails && <Tab>Details</Tab>}
              {isWeather && <Tab>Weather</Tab>}
            </div>
            <div className="tab-progress" />
            {isDetails && (
              <Panel>
                <div className="popup-details">
                  <img
                    src={item.photos[0]}
                    alt=""
                    onClick={() => {
                      setImages(item.photosZoomBox);
                      setIsOpenImageBox(true);
                    }}
                  ></img>
                  <div className="event-date">
                    {item.info.time
                      ? moment(item.info.time).format('YYYY-MM-DD HH:mm:SS')
                      : ''}
                  </div>
                  <div
                    className={
                      item.photos && item.photos.length > 1 ? 'comments' : ''
                    }
                  >
                    {item.comments.map((comment, idx) => {
                      comments = `${comments} ${comment}`;
                      return <p key={`comment_line_${idx}`}>{comment}</p>;
                    })}
                  </div>
                </div>
              </Panel>
            )}
            <Panel>
              <div className="popup-details">
                <span>
                  <table className="greyGridTable">
                    <tbody>
                      <tr>
                        <td className="label">Date</td>
                        <td>
                          {item.info.time
                            ? moment(item.info.time).format(
                                'YYYY-MM-DD HH:mm:SS'
                              )
                            : ''}
                        </td>
                      </tr>
                      <tr>
                        <td className="label">Temperature</td>
                        <td>{item.weather['TEMP']} °C</td>
                      </tr>
                      <tr>
                        <td className="label">Pressure</td>
                        <td>{item.weather['PRESSURE']} hPa</td>
                      </tr>
                      <tr>
                        <td className="label">Humidity</td>
                        <td>{item.weather['HUMIDITY']}%</td>
                      </tr>
                      <tr>
                        <td className="label">Wind Speed</td>
                        <td>{item.weather['WIND_SPEED']} km/h</td>
                      </tr>
                      <tr>
                        <td className="label">Wind Direction</td>
                        <td>
                          {degToCard(item.weather['WIND_DEG'])}/
                          {item.weather['WIND_DEG']}°
                        </td>
                      </tr>
                      <tr>
                        <td className="label">Overcast</td>
                        <td>{item.weather['OVERCAST']}%</td>
                      </tr>
                      <tr>
                        <td className="label">Condition</td>
                        <td>
                          {item &&
                            item.weather['CONDTION'] &&
                            CONDITION_MAPPING[item.weather['CONDTION']].long}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </div>
            </Panel>
            <div className="social-media">
              <div className="Demo__some-network">
                <FacebookShareButton
                  url={shareLink}
                  quote={`${comments}\n${shareFooter}`}
                  className="button"
                >
                  <FacebookIcon size={32} round={true} />
                </FacebookShareButton>
              </div>
              <div className="Demo__some-network">
                <TwitterShareButton
                  title={`${comments}\n${shareFooter}`}
                  via={''}
                  url={shareLink}
                >
                  <TwitterIcon size={32} round={true} />
                </TwitterShareButton>
              </div>
              <div className="Demo__some-network">
                <WhatsappShareButton
                  title={`${comments}\n${shareFooter}`}
                  via={''}
                  url={shareLink}
                >
                  <WhatsappIcon size={32} round={true} />
                </WhatsappShareButton>
              </div>
              <div className="Demo__some-network">
                <LinkedinShareButton
                  title={`${comments}\n${shareFooter}`}
                  via={''}
                  url={shareLink}
                >
                  <LinkedinIcon size={32} round={true} />
                </LinkedinShareButton>
              </div>
              <div className="Demo__some-network">
                <PinterestShareButton
                  description={`${comments}`}
                  media={shareLink}
                  url={shareLink}
                >
                  <PinterestIcon size={32} round={true} />
                </PinterestShareButton>
              </div>
            </div>
          </div>
        </Tabs>
      </Popup>
    </Marker>
  );
};

export { PoiMarker as default };
